(function () {
    "use strict";

    angular.module("angular.emlpayments")
    .directive("emlPrepopulatedInputMinValidation", triggerPrepopulatedInputMinValidationDirective);

    triggerPrepopulatedInputMinValidationDirective.$inject = ["$timeout"];

    function triggerPrepopulatedInputMinValidationDirective($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        }

        function link (scope, element, attrs, ngModelCtrl) {
            scope.$watch(attrs.emlPrepopulatedInputValidation, 
                function () {
                    if (element[0].value > element[0].min) {
                        $timeout(function () {
                            element[0].focus();
                            ngModelCtrl.$setDirty();
                            ngModelCtrl.$setTouched();
                            element[0].blur();
                            ngModelCtrl.$setValidity('min', true);
                        }, 100);
                    }
                }, 
            true);
        };
    };
}());